// ** React Imports
import { useContext } from "react"

// ** Component Imports
import { AbilityContext } from "context/Can"

const CanViewNavLink = props => {
  // ** Props
  const { children, navLink } = props

  // ** Hook
  const ability = useContext(AbilityContext)

  if (typeof navLink?.subject === "undefined") {
    return <>{children}</>
  }

  return ability && ability.can(navLink?.action, navLink?.subject) ? <>{children}</> : null
}

export default CanViewNavLink
